var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserGroupSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.2,
    height: 23.4,
    viewBox: "0 0 21.2 23.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user-group-search1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-group-search1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.9,12.8a2.33,2.33,0,0,1,2.3-2.3,2.3,2.3,0,0,1,0,4.6A2.33,2.33,0,0,1,9.9,12.8Zm.6,0a1.7,1.7,0,1,0,1.7-1.7A1.69,1.69,0,0,0,10.5,12.8Z",
    transform: "translate(-1.8 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,18.8c0-1.4-1.4-2.5-3.1-2.5S9,17.4,9,18.8a.3.3,0,1,1-.6,0c0-1.7,1.6-3,3.7-3s3.7,1.4,3.7,3a.27.27,0,0,1-.3.3A.32.32,0,0,1,15.2,18.8Z",
    transform: "translate(-1.8 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.9,15.6a7.3,7.3,0,1,1,7.3,7.3A7.34,7.34,0,0,1,4.9,15.6Zm1.1,0a6.2,6.2,0,1,0,6.2-6.2A6.17,6.17,0,0,0,6,15.6Z",
    transform: "translate(-1.8 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1,23.2l-1.4-1.4a.57.57,0,0,1,.8-.8l1.4,1.4a.6.6,0,0,1,0,.8.52.52,0,0,1-.4.2A.76.76,0,0,1,20.1,23.2Z",
    transform: "translate(-1.8 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_39",
    "data-name": "Capa 39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.8,3.5A2.69,2.69,0,0,1,6.5.8,2.61,2.61,0,0,1,9.1,3.5,2.58,2.58,0,0,1,6.5,6.1,2.74,2.74,0,0,1,3.8,3.5Zm.7,0a2,2,0,1,0,2-2A2,2,0,0,0,4.5,3.5Z",
    transform: "translate(-1.8 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2,10.7c0-2,1.9-3.6,4.3-3.6a6.75,6.75,0,0,1,1.4.2.76.76,0,0,1,.2.5c-.1.2-.2.3-.4.2a4.87,4.87,0,0,0-1.2-.1c-2,0-3.6,1.3-3.6,2.9a.32.32,0,0,1-.3.3C2.5,11.1,2.2,10.9,2.2,10.7Z",
    transform: "translate(-1.8 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_40",
    "data-name": "Capa 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.3,6.1a2.58,2.58,0,0,1-2.6-2.6A2.65,2.65,0,0,1,18.3.9a2.58,2.58,0,0,1,2.6,2.6A2.65,2.65,0,0,1,18.3,6.1Zm0-4.6a2,2,0,1,0,2,2A2.07,2.07,0,0,0,18.3,1.5Z",
    transform: "translate(-1.8 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2,11.1a.32.32,0,0,1-.3-.3c0-1.6-1.6-2.9-3.6-2.9a5,5,0,0,0-1.2.2.32.32,0,0,1-.2-.6,5.9,5.9,0,0,1,1.4-.2c2.4,0,4.3,1.6,4.3,3.6A.7.7,0,0,1,22.2,11.1Z",
    transform: "translate(-1.8 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.8 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-1.8 -0.4)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroupSearch);
export default __webpack_public_path__ + "static/media/user-group-search.6ab4c9f4f7f30ee2866e488826d5a245.svg";
export { ForwardRef as ReactComponent };